import React from "react"
import { bar } from './index.module.scss'

const Bar = ({ width, color }) => <div className={bar} style={{ backgroundColor: color, width }}/>

export default Bar
